import { Injectable } from '@angular/core';
import { UserActionBaseComponent } from 'app/catalog/functions/userAction/userAction-base.component';

@Injectable({
  providedIn: 'root'
})
export class MacroService {
  workflowMode: boolean;
  targetCatalogId: string;


}
